// Typelizer digest 4d16de453de75e5db2bd57fba1d935f6
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /contact/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/contact/new', {}, options),
    method: 'get',
  }),

  /** POST /contact */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/contact', {}, options),
    method: 'post',
  }),
}
